import { useCallback, useEffect, useRef } from "react"
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@mui/material"

export interface ConfirmActionDialogProps {
  open: boolean
  title: string
  body: string
  confirmLabel: string
  onClose: () => void
  onConfirm: () => void
}

export function ConfirmActionDialog({ open, title, body, confirmLabel, onClose, onConfirm }: ConfirmActionDialogProps) {
  const hasConfirmed = useRef(false)
  useEffect(() => {
    if (open) hasConfirmed.current = false
  }, [open])

  const handleConfirm = useCallback(() => {
    if (hasConfirmed.current) return
    hasConfirmed.current = true
    onConfirm()
  }, [onConfirm])

  return (
    <Dialog open={open} onClose={onClose} data-testid="kelly-confirm-action-dialog">
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <DialogContentText>{body}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button onClick={handleConfirm} color="warning" data-testid="kelly-confirm-action-confirm">{confirmLabel}</Button>
      </DialogActions>
    </Dialog>
  )
}
